/** 
 * Je potrebne vlozit do HTML
 * <div class="load-products-wrap" products-url="/URL/" products-count="COUNT"></div>
 */

function loadProductsCarousel() {
  var loadProductsNumber = window.innerWidth <= bpMedium ? 2 : 3;

  $(".load-products-wrap[products-url]").each(function () {
    var $this = $(this);

    if ($this.hasClass("products-loading")) return;

    $this.addClass("products-loading");

    var sourceUrl = $this.attr("products-url");
    var productCount = parseInt($this.attr("products-count")) || 3;

    $.get("/cache" + sourceUrl, function (response) {
      var $html = $("<div>").html(response);

      var $products = $html.find(".products.products-block .product").slice(0, productCount);

      if ($products.length === 0) {
        $this.hide();
        return;
      }

      $this.empty().append($products);

      // Lazy-load obrázky
      $products.find("img[data-src]").each(function () {
        var img = $(this);
        img.attr("src", img.attr("data-src")).removeAttr("data-src");
      });

      // Ak už je carousel, nespúšťame znova
      if ($this.hasClass("carousel-initialized")) return;

      if ($products.length > loadProductsNumber) {
        $this.addClass("products products-block products-related products-additional p-switchable");
        $this.addClass("article_products_wrap carousel__specific_style");
        $products.addClass("carousel__slide");

        $this.find(".carousel_nav, .carousel_dots").remove();

        new Carousel($this[0], {
          Dots: true,
          Navigation: true,
          Autoplay: false,
        });

        $this.addClass("carousel-initialized");
      }
    });
  });
}
